import { createContext } from "react";

import { CardCollapsibleContextType } from "./types";

export const CardCollapsibleContext = createContext<CardCollapsibleContextType | undefined>(
  undefined
);
